<script setup>
</script>
<template >
  <template
      v-if="list"
  >
  <div
    class="masonry-container row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-2"
  >
    <template
      v-for="(item, index) in list"
    >
      <div
          v-if="item.display"
          class="wrap-list-item  masonry-item"
      >
        <div
          class="border border-secondary-subtle rounded-3 pt-2 pb-1"
        >
          <ExpandableText
              @toggle="refreshDisplay()"
              :maxHeight="150"
          >
            <small
                v-if="item.created_date"
                class="d-block text-muted mx-2 mb-1"
            >
              <i class="bi bi-clock me-1"/>
              <span
                  v-format-date.showTime=item.created_date
              />
            </small>

            <div
                v-if="item.note"
                class="text-muted mx-2"
            >
              {{item.note}}
            </div>

            <hr
                v-if="item.note && item.file && Object.keys(item.file).length > 0"
                class="mt-1 mx-3"
            />

            <div
                v-if="item.file && Object.keys(item.file).length > 0"
                class="lh-base mx-2"
            >
              <template
                  v-for="(fileData, fIndex) in item.file"
              >
                <file-attachment-info
                    :file-id="fileData.id"
                    :filename="fileData.file"
                    :info="fileData.info"
                />
              </template>
            </div>


          </ExpandableText>
        </div>
      </div>
    </template>


  </div>
  <div
      v-if="countDisplayItems() < list.length"
      class="my-2 text-center"
  >
    <button
        @click.prevent="displayListNextStep()"
        class="btn btn-sm btn-outline-primary"
    >
      {{countDisplayItems()}}/{{list.length}}
    </button>

  </div>


  </template>
  <template
    v-else
  >
    [nejsou zadna data]
  </template>


  <div
    class="mt-2"
  >
    <textarea
      v-model="form.note"
      class="form-control"
      rows="3"
      placeholder="Zadejte poznamku"
    ></textarea>

    <file-attachment-upload
        :key="form.key"
        v-model="form.file"
        accept-mime-type="*/*"
    />

    <div class="row align-items-center">
      <div class="col text-end logs ">
        <div
          v-if="form.message.success"
          v-fade-out-element="5000"
          class="text-success"
        >
          <i class="bi bi-check-circle-fill me-1"/>
          {{form.message.success}}
        </div>
        <div
            v-if="form.message.error"
            v-fade-out-element="5000"
            class="text-danger"
        >
          <i class="bi bi-exclamation-triangle-fill me-1"/>
          {{form.message.error}}
        </div>


<!--
        <div
          v-if="form.key"
          v-fade-out-element="5000"
          class="text-info"
        >
          [v-fade-out-element {{form.key}}]
        </div>
-->
        <!--
          <div class="text-danger mt-2">
            <i class="bi bi-exclamation-triangle-fill me-1"/>
            Testovaci chyba
          </div>
        -->
      </div>
      <div class="col col-auto text-end">
        <button
            @click.prevent="sendEntry()"
            class="btn btn-primary mt-2"
            :disabled="!(form.note || (form.file && form.file.length > 0))"
        >
          <i class="bi bi-send me-1"/>
          Pridat prispevek
        </button>
      </div>
    </div>

  </div>

  <!--
    <display-debug>
      <template #debugView>
        form: {{form}}
      </template>
    </display-debug>


    <display-debug>
      <template #debugView>
        inputObj: {{inputObj}}
      </template> </display-debug>



    <display-debug>
      <template #debugView>
        inputObj.val: {{inputObj.val}}
      </template>
    </display-debug>






    <display-debug>
      <template #debugView>
        videoData: {{videoData}}
      </template>
    </display-debug>
    -->
</template>

<script>
import Masonry from 'masonry-layout';
import axios from "axios";
import fileAttachmentInfo from "@/components/content/fileAttachmentInfo.vue";
import fileAttachmentUpload from "@/components/content/fileAttachmentUpload.vue";
import ExpandableText from "@/components/content/ExpandableText.vue";
export default {
  name: "EntriesInput",
  emits: ['update:modelValue'],
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  components: {
    fileAttachmentInfo,
    fileAttachmentUpload,
    ExpandableText,
  },
  data() {
    return {
      msnry: null,
      list: [],
      form: {
        note: null,
        file: null,
        key: null,
        message: {
          success: null,
          error: null,
        }

      }
    }
  },
  mounted() {
    if(
      this.inputObj.val
       && this.inputObj.val.data
    ){
      let i =1
      for (const [index, value] of Object.entries(this.inputObj.val.data)) {
        let displayStatus = false;
        if(i <= this.inputObj.params.list.display_limit) {
          displayStatus = true;
        }
        this.list.push(
            {...value, display: displayStatus}
        )
        i++;
      }
    }

    this.$nextTick(() => {
      this.refreshMasonry();

    });



  },
  beforeUnmount() {

  },
  computed: {},

  methods: {
    refreshDisplay() {
      console.log('dev refreshDisplay')
      this.$nextTick(() => {
        this.refreshMasonry();
      });
    },
    setFormMessage(message, type = 'success', delay = 15){

      this.form.message[type] = message;
      setTimeout(() => {
        this.form.message[type] = null;
      }, delay * 1000);

    },
      setVariable(variable, value, delay = 15){
        console.log('setVariable IN', variable, value, delay)
        variable = value;
        setTimeout(() => {
          console.log('setVariable setTimeout', variable, delay)
          variable = false;
        }, delay * 1000);
      },
      refreshMasonry(){
        setTimeout(() => {
          console.log('refreshMasonry')
          this.msnry = new Masonry('.masonry-container', {
            itemSelector: '.masonry-item',
            columnWidth: '.masonry-item',
            percentPosition: true,
            gutter: 0 // mezera mezi bloky
          });

        }, 100)

      },
      countDisplayItems(){
        return this.list.filter(item => item.display).length;
      },
      displayListNextStep(){
        let j = 1;
        for (const i in this.list) {
          if (this.list[i].display == false) {
            if(j <= this.inputObj.params.list.display_step) {
              this.list[i].display = true;
              j++;
            }
          }
        }
        console.log('displayListNextStep', this.list)
        this.$nextTick(() => {
          this.refreshMasonry();
        });
      },
      async sendEntry() {
        const formData = new FormData();
        formData.append('data', JSON.stringify(this.form));
        formData.append('customer_id', this.inputObj.val.id);
        //formData.append('files', JSON.stringify(this.form));

        axios.defaults.baseURL = this.getBaseRoot();
        await axios({
          url: this.inputObj.params.send.path,
          method: this.inputObj.params.send.method,
          withCredentials: true,
          headers: this.getRequestHeader(),
          data: formData,
        }).then((res) => {
          this.setFormMessage(
              'Pridano v poradku #2',
              'success',
              6
          )
          //this.form.message.success = res.data.message;
          this.list.unshift(
              {...res.data.response.entry, display: true}
          );
        }).catch((err) => {
          this.err = "openLink nenalezen, kontaktujte spravce"
        }).finally((f) => {
          this.form.note = null;
          this.form.file = [];
          this.form.key = Math.random();

          this.refreshMasonry();
        })
      }

  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },

    inputModel: {
      handler(newVal) {
        //newVal.ad = this.ad;
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
<style scoped>
.wrap-list-item {

  border: 0px solid red;
}
</style>